<template>
  <Question
    :next-button-theme="nextButtonTheme"
    :subtitle="$t('kyc.titles.identity')"
    :title="$t('kyc.questions.children')"
    :progress-ratio="5/8/4"
    back-route="/kyc/marital-status"
    @next="next"
  >
    <BaseSection>
      <BaseRadioButtons
        :value="hasChildren"
        :items="items"
        class="mb-4"
        @input="updateHasChildren"
      >
        <BaseRadioButton
          slot-scope="slotProps"
          :active="slotProps.item === hasChildren"
          class="text-xl"
        >
          {{ slotProps.item.title }}
        </BaseRadioButton>
      </BaseRadioButtons>
    </BaseSection>
  </Question>
</template>

<script>
import Question from './Question.vue';
import { HAS_CHILDREN_ITEMS } from '../../constants';
import BaseSection from '../../components/BaseSection.vue';
import BaseTitleGroup from '../../components/BaseTitleGroup.vue';
import BaseRadioButtons from '../../components/BaseRadioButtons.vue';
import BaseRadioButton from '../../components/BaseRadioButton.vue';
import kyc from '../../mixins/kyc';

export default {
  name: 'Children',
  components: {
    BaseSection,
    BaseTitleGroup,
    BaseRadioButtons,
    BaseRadioButton,
    Question,
  },
  mixins: [kyc],
  data() {
    return {
      hasChildrenTemp: null,
    };
  },
  computed: {
    hasChildren() {
      if (this.hasChildrenTemp !== null) {
        return this.hasChildrenTemp;
      }
      if (this.form.attributes.childrenAges && this.form.attributes.childrenAges.length) {
        return this.items[1];
      }
      return null;
    },
    items() {
      return HAS_CHILDREN_ITEMS;
    },
    nextButtonTheme() {
      if (this.hasChildren) {
        return 'primary';
      }
      return 'disabled';
    },
  },
  methods: {
    next() {
      if (this.hasChildren.id === 1) {
        this.$router.push('/kyc/ppe');
      } else if (this.hasChildren.id === 2) {
        this.$router.push('/kyc/children-details');
      }
    },
    updateHasChildren(value) {
      this.hasChildrenTemp = value;
    },
  },
};
</script>
